import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "ieg_portal_token";
export const ADMIN_TOKEN_KEY = "ieg_portal_admin_token";
export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMessage(e) {
  return formatApiError(e?.response?.data?.detail) || e?.message || "Request failed.";
}

// Append token for <img src> / direct file links (backend accepts ?auth=)
export function fileAuthUrl(path) {
  if (!path) return path;
  const base = path.startsWith("http") ? path : `${API}${path}`;
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return base;
  return base + (base.includes("?") ? "&" : "?") + "auth=" + encodeURIComponent(token);
}
